<div class="loader-background" [class._dark]="darkBackground" [class._white]="whiteBackground" [class._transparent]="transparent" [class._modal]="modal">
    <div class="loader" [class._modal]="modal" [class._light]="darkBackground"></div>
    <div id="preventClick" *ngIf="preventClick"></div>
</div>